import AnimationsSection from "./AnimationsSection";
export default AnimationsSection;
